import { Loader2 } from 'lucide-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuthStore } from '@/stores/auth-store';

/**
 * Penjaga rute untuk halaman yang memerlukan autentikasi.
 *
 * Selama sesi masih dipulihkan, halaman menampilkan indikator muat —
 * tanpa itu, pengguna yang sebenarnya sudah masuk akan sempat terlempar
 * ke halaman login setiap kali me-refresh browser.
 */
const FORCED_PASSWORD_CHANGE_PATH = '/ganti-sandi-wajib';

export function ProtectedRoute() {
  const location = useLocation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isInitializing = useAuthStore((state) => state.isInitializing);
  const mustChangePassword = useAuthStore((state) => state.user?.mustChangePassword);

  if (isInitializing) {
    return (
      <div className="flex min-h-dvh items-center justify-center" role="status" aria-live="polite">
        <Loader2
          className="size-6 animate-spin text-[var(--color-muted-foreground)]"
          aria-hidden="true"
        />
        <span className="sr-only">Memuat sesi...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Simpan tujuan awal agar bisa dikembalikan setelah berhasil masuk.
    return <Navigate to="/masuk" state={{ from: location.pathname }} replace />;
  }

  if (mustChangePassword && location.pathname !== FORCED_PASSWORD_CHANGE_PATH) {
    return <Navigate to={FORCED_PASSWORD_CHANGE_PATH} replace />;
  }

  return <Outlet />;
}
